import { Flex } from '@radix-ui/themes'
import loginBackgroundImageUrl from '@/assets/image/login_bg.jpg'
import LoginLogo from '@/assets/image/login_logo.png'
import LoginOverlay from '../components/LoginOverlay'
import Star from '../components/Star'
import { UserAuthForm } from './components/user-auth-form'

export default function SignIn2() {
  return (
    <div className='relative container grid h-svh flex-col items-center justify-center lg:max-w-none lg:grid-cols-2 lg:px-0'>
      <div
        style={{ backgroundImage: `url(${loginBackgroundImageUrl})` }}
        className='relative h-full w-full bg-cover bg-center bg-no-repeat p-10 text-white'
      >
        <div className='absolute top-0 right-0 bottom-0 left-0 w-full'>
          <LoginOverlay />
        </div>
        <div className='absolute right-0 bottom-0 left-0 h-[70%] bg-linear-to-b from-[#00000000] to-[#00000099]'></div>

        <div className='absolute bottom-[100px] left-[50%] flex min-w-[592px] -translate-x-[50%] flex-col gap-5'>
          <Star />
          <p className='text-left text-[60px] leading-[72px] font-semibold'>
            Welcome to KCB Companion App
          </p>

          <Flex align={'center'}></Flex>
        </div>
      </div>
      <div className='lg:p-8'>
        <div className='mx-auto flex w-full flex-col justify-center space-y-2 sm:w-[350px]'>
          <div className='flex flex-col space-y-2 text-left'>
            <img src={LoginLogo} alt='kcb logo' className='mb-4'></img>
          </div>
          <p className='text-center text-2xl font-semibold'>Admin portal</p>
          <UserAuthForm />
        </div>
      </div>
    </div>
  )
}
